import { Inject, Injectable } from '@angular/core';
import { RmService } from '@bidi/common-services';
import { createFeatureSelector, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from './ngrx/reducers';
import {
  GetRatings
} from './ngrx/actions';

@Injectable()
export class RatingsService {
  static featureName = '@bidi/common-components Ratings';
  processDataRatings: any;

  constructor (
    private store: Store<any>,
    private rm: RmService
  ) {
  }

  private state$: Observable<State> = this.store.pipe(select(createFeatureSelector(RatingsService.featureName)));

  ratings$: Observable<any> = this.state$.pipe(select('ratings'));

  getRatings (id: string) {
    this.store.dispatch(new GetRatings(id));
  }

  processRatings (userName) {
    /*this.ratings$.pipe(select('ratings')).subscribe(
      data => {
        let range = 0;
        let rangeTeachers = 0;
        let totalTeachers = 0;
        let rangeStudent = 0;
        let totalStudent = 0;
        let total = 0;
        data.map(function(d) {
          if (userName === d.user) {
            // this.flagUser = false;
          }
          range = range + parseInt(d.range, 0);
          if (d.type === 'docente') {
            rangeTeachers = rangeTeachers + parseInt(d.range, 0);
            totalTeachers++;
          }
          if (d.type === 'estudiante') {
            rangeStudent = rangeStudent + parseInt(d.range, 0);
            totalStudent++;
          }
          total++;
        });
        const average = range / total;
        this.processDataRatings = {
          'average': (5 - average) * 20,
          'averageStudetCal': (5 - (rangeStudent / totalStudent)) * 20,
          'averageTeacherCal': (5 - (rangeTeachers / totalTeachers)) * 20,
          'averageTeacher': rangeTeachers / totalTeachers,
          'averageStudent': rangeStudent / totalStudent,
          'totalStudent': totalStudent,
          'totalTeachers': totalTeachers,
          'total': total
        };
      }
    );
    return this.processDataRatings;
    */
  }
}
